import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
export const StyledSummaryList = styled('div')(
  ({ theme }) => `
   ul {
    margin: ${theme.DS_spacing(['md'])} 0;
    
   .address-summary, .phone-number-summary {
     color: ${theme.DS_palette.text.secondary};
   }
   
  .time-summary{
   display: flex;
  align-items: center;
  }
  }
`,
);

export const StyledDate = styled(Typography)(
  ({ theme, $noBookingAvailable, $timeOut }) => `

     color: ${
       $noBookingAvailable || $timeOut ? `${theme.DS_palette.text.secondary}` : `${theme.DS_palette.text.primary}`
     };
     text-decoration: ${$noBookingAvailable ? `line-through` : `none`};
  

`,
);

export const StyledCancellationNote = styled(Typography)(
  ({ theme }) => `

     color: ${theme.DS_palette.buttons.error};
   

`,
);

export const StyledWrapperDate = styled('div')(
  ({ theme }) => `
   border-bottom: 1px solid ${theme.DS_palette.border.form};
   border-top: 1px solid ${theme.DS_palette.border.form};
   padding: ${theme.DS_spacing(['md'])} 0;
   margin-bottom: ${theme.DS_spacing(['md'])};

`,
);

export const StyledSvgIcon = styled('span')(
  ({ theme }) => `
     margin-right: 12px;
     svg {
      fill: none;
      font-size: 32px;
     }
     
     ${theme.breakpoints.up('lg')} {
      svg {
        font-size: 40px;
      }
     }

`,
);
